import React, { useContext, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import Tooltip from 'components/Tooltip'
import { useNavigate, useLocation } from 'react-router-dom'
import { ProfileContext } from 'providers/profile'
import { MySiteContext } from 'providers/mySiteProvider'
import ProfileIcon from 'components/ProfileIcon'
import Button from 'components/Button'
import AddNew from 'assets/icons/add-new'
import ImportIcon from 'assets/icons/import-icon'
import NotificationIcon from '../Notification'
import ProfileDropdown from '../ProfileDropdown'
import { canCreateSites } from 'utils/rolePermissions'
import { requestProposeSite } from 'api/site'
import { LEGAL_TERM_PATH, REPORTS_PATH } from 'routing/constants'
import SingleDot from 'assets/icons/single-dot'
import Switch from 'components/Switch'
import BulkImportModal from '../BulkImportModal'
import Modal from 'components/Modal'
import FlowRequestModal from 'components/FlowRequestModal'

import {
  HeaderTopBarNotificationWrapper,
  TopBarButtonWrapper,
  TopBarCategoryTitle,
  TopBarLeftSideWrapper,
  TopBarProfile,
  TopBarRightSideWrapper,
  TopBarWrapper,
  Divider,
  MySitesCounterWrapper,
  StyleSingleDot,
  TotalSitesCounterBox, HeaderTotalSitesTextWrapper
} from './style'

const tooltipXOffset = 0
const tooltipYOffset = 16
const AuthorizedHeader = () => {
  const { profile } = useContext(ProfileContext)
  const { isMySite, setIsMySite, allSiteLength, mySiteLength } = useContext(MySiteContext)
  const [file, setFile] = useState({ file: { name: 'text' } })
  const [isImportModalOpen, setIsImportModalOpen] = useState(false)
  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false)
  const location = useLocation()
  const history = useNavigate()
  const isLegalTerm = LEGAL_TERM_PATH === location.pathname
  const isReportsPage = REPORTS_PATH === location.pathname

  function handleProposeSite() {
    requestProposeSite().then((data) => {
      history(`/site/${data.id}/about`)
    })
  }

  function closeRemoveFileModal() {
    setIsRemoveModalOpen(false)
  }

  function closeImportModal() {
    setIsImportModalOpen(false)
    setFile({ file: { name: 'text' } })
  }

  function removeFileToImport() {
    setIsImportModalOpen(false)
    setIsRemoveModalOpen(false)
    setFile({ file: { name: 'defaultFile9999999' } })
  }

  return (
    <>
      <TopBarWrapper style={{ position: isLegalTerm ? 'fixed' : '', paddingRight: isLegalTerm ? '160px' : '' }}
        data-test='header'>
        <TopBarLeftSideWrapper>
          <TopBarCategoryTitle data-test='page-header'>
            <FormattedMessage id={location.pathname} />
          </TopBarCategoryTitle>
          {location.pathname === '/sites' &&
            <MySitesCounterWrapper>
              <StyleSingleDot>
                <SingleDot />
              </StyleSingleDot>
              <HeaderTotalSitesTextWrapper>
                <FormattedMessage id='totalSites' />
              </HeaderTotalSitesTextWrapper>
              <TotalSitesCounterBox>
                {allSiteLength || 0}
              </TotalSitesCounterBox>
              <Divider />
              <FormattedMessage id='mySites' values={{ mySitesNumber: <>{`(${mySiteLength || 0})`}</> }} />
              <Switch
                id='toggleSwitch'
                toggled={isMySite}
                onChange={setIsMySite}
              />
            </MySitesCounterWrapper>
          }
          {isLegalTerm && (
            <MySitesCounterWrapper>
              <StyleSingleDot>
                <SingleDot />
              </StyleSingleDot>
              <div style={{ color: 'rgba(32, 32, 32, 0.7)', fontWeight: '400' }}>
                <FormattedMessage id='localTermsUpdatedOn' />
              </div>
              <div style={{ fontWeight: '500', marginLeft: '5px' }}>
                <FormattedMessage id='dateUpdatedOn' />
              </div>
            </MySitesCounterWrapper>
          )}
        </TopBarLeftSideWrapper>
        <TopBarRightSideWrapper>
          {!isLegalTerm && !isReportsPage && (profile.hasBulkImportAccess || canCreateSites(profile.RoleId)) && (
            <TopBarButtonWrapper>
              {profile.hasBulkImportAccess && (
                <Button dataTest='import-modal' marginTop='0' height='40px' onClick={() => {
                  setIsImportModalOpen(true)
                }}>
                  <ImportIcon />
                  <FormattedMessage id='importData' />
                </Button>
              )}
              {canCreateSites(profile.RoleId) && (
                <Button dataTest='propose-site' marginTop='0' height='40px' type='primary' onClick={handleProposeSite}>
                  <AddNew />
                  <FormattedMessage id='proposeSite' />
                </Button>
              )}
            </TopBarButtonWrapper>
          )}
          <HeaderTopBarNotificationWrapper data-test='notification'>
            <Tooltip
              style={{ zIndex: 1000 }}
              placement='bottom'
              trigger={['hover']}
              align={{ offset: [tooltipXOffset, tooltipYOffset] }}
              overlay={{ label: 'notification' }}
            >
              <NotificationIcon />
            </Tooltip>
          </HeaderTopBarNotificationWrapper>
          <TopBarProfile>
            <ProfileIcon user={profile} />
          </TopBarProfile>
          <ProfileDropdown />
        </TopBarRightSideWrapper>
      </TopBarWrapper>
      <BulkImportModal
        isOpen={isImportModalOpen && !isRemoveModalOpen}
        file={file}
        toggleModal={closeImportModal}
        setFile={setFile}
        openRemoveFileModal={setIsRemoveModalOpen}
      />
      <Modal
        isOpen={isRemoveModalOpen}
        toggleModal={setIsRemoveModalOpen}
        modalTitleId='removeFile?'
        width='416px'
      >
        <FlowRequestModal
          cancelHandler={closeRemoveFileModal}
          confirmHandler={removeFileToImport}
          text={<FormattedMessage id='removeFileText' values={{ title: file.file.name }} />}
          approve={false}
          confirmBtnText='yesRemove' />
      </Modal>
    </>
  )
}

export default AuthorizedHeader
